import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import { FirebaseDocRefType } from 'firebase'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { PointCardCodeType as BasicPointCardCodeType } from 'types/pointCard/pointCardCode'
import classNames from 'classnames'

type PointCardCodeType = BasicPointCardCodeType & { ref: FirebaseDocRefType }

type Props = {
  pointCardCodes: PointCardCodeType[]
}

const PointCardCodeList: FC<Props> = (props) => {
  const { pointCardCodes } = props
  const dispatch = useDispatch()

  return (
    <ul className={styles.pointCardCode__list}>
      {pointCardCodes.map((pointCardCode) => (
        <li
          className={styles.pointCardCode__inner}
          key={pointCardCode.ref.id}
          onClick={() => dispatch(push(`/point_card/code/${pointCardCode.ref.id}`))}
        >
          <div className={styles.pointCardCode__label}>
            <div className={styles.pointCardCode__items}>
              <p className={classNames(text.font_bold, text.font_medium, text.color_blue_main)}>{pointCardCode.name}</p>
              <p className={text.font_small}>
                付与するポイント
                <span className={classNames(text.font_small, text.color_blue_main)}>：{pointCardCode.points}pt</span>
              </p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default PointCardCodeList
